import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';
import { truncate } from 'flarum/common/utils/string';

import { clubForDiscussion } from '../../common/clubs';

export default class ClubMentionedNotification extends Notification {
  icon() {
    return 'fas fa-bullhorn';
  }

  href() {
    const post = this.attrs.notification.subject();

    return app.route.discussion(post.discussion(), post.number());
  }

  content() {
    const user = this.attrs.notification.fromUser();
    const post = this.attrs.notification.subject();
    const club = post && clubForDiscussion(post.discussion());

    return app.translator.trans('happydigital-clubs.forum.notifications.club_mentioned_text', {
      user,
      club: club ? club.name : post && post.discussion() ? post.discussion().title() : '',
    });
  }

  excerpt() {
    return truncate(this.attrs.notification.subject().contentPlain(), 200);
  }
}
